import type { ReactNode } from "react";
import { useDialogFocus } from "./use-dialog-focus";
import "./ship-supplies.css";

export function ShipSuppliesDialog({
  shipName,
  children,
  onClose,
  returnTo = "ангар",
}: {
  shipName: string;
  children: ReactNode;
  onClose: () => void;
  returnTo?: "ангар" | "магазин";
}) {
  const panel = useDialogFocus(onClose);
  return (
    <div className="ship-supplies-backdrop">
      <section
        className="ship-supplies-dialog"
        ref={panel}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-label={`Трюм корабля «${shipName}»`}
      >
        <header>
          <div>
            <span className="station-page-kicker">ПОДГОТОВКА КОРАБЛЯ</span>
            <h2>Трюм · {shipName}</h2>
          </div>
          <button onClick={onClose} aria-label={`Вернуться в ${returnTo}`}>
            ← <span>В {returnTo}</span>
          </button>
        </header>
        <div className="ship-supplies-content">{children}</div>
      </section>
    </div>
  );
}
